__webpack_require__.p = "https://sports.whcdn.net/football/build-yourodds/es/es-es/desktop/0.42.12/";